import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
//import {base} from "../../../environments/environment";

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss']
})
export class EmailVerificationComponent implements OnInit {
  verified!: number;
  key!: number;
  code!: string;
  email!: string;
  TransLang: string[] = [];
  baseUrl = ""

  constructor(private route: ActivatedRoute,

    private translate: TranslateService,) {
    translate.setDefaultLang('mk');
    translate.addLangs(['mk', 'al'])
  }

  ngOnInit(): void {
    this.getTransLanguage();
    this.route.queryParams
      .subscribe(params => {
        this.verified = params['success'];
        this.key = params['key'];
        this.code = params['code'];
        this.email = params['email'];
      }
      );
  }

  getTransLanguage() {
    this.TransLang = [...this.translate.getLangs()];
  }
}
